<template>
  <div class="projects-box">

       <div class="addPoject-box" >
             <div class="addProject">
               <p>Ein neues Projekt anlegen </p>
               <p><input v-model="newProjectName"></p>
             </div>
       </div>

       <div class="projects-box-button-box">
         <button v-on:click="addProject()">Projekt anlegen</button>
       </div>
  </div>
</template>
<script>
import config from '../_config/config';

export default {
  name: 'addProject',
  data () {
    return {
      newProjectName: "",
    }
  },
  computed: {
/*
      projects () {
          return this.$store.state.projects.all
        },
*/
  },
  created(){
      this.config = config
  },
  methods: {
      closeOverlay(){
        this.$emit('closeOverlay')
      },
      addProject(){
        
        if( this.newProjectName =="" ) return;
        
        let project =  { id: null, data: { name: '', desc:'', products:[] }, access: [] }
        //project.data.products.push( this.articlenumber )
        project.data.name = this.newProjectName
        console.log(project);
        
        this.saveProject( project, () => { 
          this.$emit('closeOverlay')
          this.$store.dispatch('projects/getAll')
          })
        
        
      },
            
        
      saveProject( project, cb = null ) {

            const { id, data, access } = project;
            const { dispatch } = this.$store;

                dispatch('projects/save', { id, data, access })
                  .then( (res ) => {
                      if( res.success )
                      console.log('Project saved')
                      
                      typeof cb == "function" && cb()
                      //this.openOverlayA = false;
                      //this.$router.push('/manager/product/' + this.newproduct );
                      //this.id = this.getSavedProduct.last_insert_id
                  });


        },
  }
}
</script>
<style scoped>

  .projects-box .addPoject-box { padding: 0 0 1.4333em 0; } 
  .projects-box .addPoject-box .addProject { padding: 0; }
  .projects-box .addPoject-box .addProject i { display: inline-block; margin-top: 1px; }
  .projects-box .addPoject-box .addProject input { display: inline-block; margin: 0 0.4333em 0 0; outline: none; }
  .projects-box .addPoject-box .addProject p { display: flex; }
    
  .projects-box-button-box { text-align: center; }
  .projects-box-button-box button { text-align: center; }
</style>



